export default __webpack_public_path__ + "static/media/cs-c001-Picture2.e35fcb26.png";